<template>
<div class="customer-reviews">
  <h4 class="fw-bold mb-4">{{ $t('show_view.customer_reviews') }}</h4>

  <div class="review-summaries mb-5">
    <div class="left">
      <div class="fw-bold">
        <span class="fs-3">{{ product.rating }}</span>
        <span class="text-muted">/ 5</span>
      </div>
      <div class="fs-3 my-3">
        <rate-star :value="product.rating"/>
      </div>
      <div class="text-muted">
        {{ $t('shared.x_reviews', { count: product.totalReviews }) }}
      </div>
    </div>
    <div class="right">
      <div class="star-grid">
        <template v-for="(rs, idx) of reviewSummaries" :key="idx">
          <div class="fw-bold">{{ rs.rating }}.0</div>
          <div class="progress">
            <div class="progress-bar" :style="{ width: `${rs.percent * 100}%` }"/>
          </div>
          <div class="text-end">{{ $t('shared.x_reviews', { count: rs.count }) }}</div>
        </template>
      </div>
    </div>
  </div>

  <div class="review-list mb-5">
    <div class="review" v-for="review of reviews" :key="review.reviewReference">
      <div class="review-header mb-3">
        <div class="d-flex align-items-center mb-2 mb-lg-0">
          <img src="@/assets/icons/avatar_reviews.png" class="avatar">
          <div>
            <div class="fw-bold">{{ review.userName }}</div>
            <div class="small text-muted">{{ formatDateTime(review.publishedDate) }}</div>
          </div>
        </div>
        <div class="ratings">
          <rate-star :value="review.rating"/>
        </div>
      </div>
      <div class="review-body">
        <div class="mb-3">
          <clamp-text :value="review.text"/>
        </div>

        <swiper class="mb-3" v-if="review.photos"
            :modules="swiperModules"
            navigation
            :slides-per-view="4"
            :space-between="20">
          <swiper-slide v-for="(url, idx) of review.photos" :key="idx">
            <img class="photo" :src="imageUrl(url)" @click="handleShowImage(review.photos, idx)">
          </swiper-slide>
        </swiper>

        <div class="merchant-info p-3" v-if="review.ownerResponse">
          <div class="fw-bold">{{ review.ownerResponse.userName }}</div>
          <div class="mb-3">{{ formatDateTime(review.ownerResponse.publishedDate) }}</div>
          <clamp-text :value="review.ownerResponse.text"/>
        </div>
      </div>
    </div>
  </div>

  <div class="d-lg-flex justify-content-between align-items-center">
    <el-pagination
      background hide-on-single-page
      layout="prev,pager,next"
      :pager-count="5"
      v-model:current-page="page"
      v-model:page-size="pageSize"
      :total="total"/>
    <div class="order-first small text-muted text-center mt-3 mt-lg-0">Visit www.discovercity.com for more great reviews</div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper'
import { Fancybox } from '@fancyapps/ui'
import RateStar from '@/components/RateStar'
import ClampText from '@/components/ShowView/ClampText'

export default {
  components: { Swiper, SwiperSlide, RateStar, ClampText },

  props: ['product'],

  data () {
    return {
      swiperModules: [Navigation],
      page: 1,
      pageSize: 5
    }
  },

  computed: {
    reviewSummaries () {
      const list = _.clone(this.product.productReviews || [])
      list.reverse()
      return list
    },

    reviews () {
      const list = this.product.reviews || []

      const startIdx = (this.page - 1) * this.pageSize
      const endIdx = startIdx + this.pageSize

      return list.slice(startIdx, endIdx)
    },

    total () {
      return (this.product.reviews || []).length
    }
  },

  methods: {
    formatDateTime (str) {
      const date = new Date(str)
      return date.toLocaleString()
    },

    imageUrl (url) {
      return process.env.VUE_APP_DATA_URL + url
    },

    handleShowImage (urls, idx) {
      Fancybox.show(
        urls.map(it => ({ src: this.imageUrl(it), type: 'image' })),
        { startIndex: idx }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/bootstrap_tools";

.customer-reviews {
  .review-summaries {
    > .left {
      display: flex; flex-direction: column; align-items: center;
      margin-bottom: 40px;
    }
    > .right {
      .star-grid {
        display: grid;
        grid-template-columns: auto 1fr auto;
        grid-gap: 20px;
        align-items: center;
        .progress {
          height: 8px;
          &-bar { background: #f5863a; }
        }
      }
    }
    @include media-breakpoint-up(lg) {
      display: flex; align-items: center;
      > .left {
        flex: 0 0 auto;
        margin-bottom: 0;
      }
      > .right {
        flex: 1 1 auto;
        margin-left: 80px;
        padding-left: 80px;
        border-left: 1px solid #ccc;
      }
    }
  }
  .review-list {
    .review {
      &:not(:last-child) .review-body {
        margin-bottom: 30px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }
      &-header {
        @include media-breakpoint-up(lg) {
          display: flex; justify-content: space-between;
        }
        .ratings { padding-left: 70px; }
        .avatar {
          width: 50px; height: 50px;
          border-radius: 50%;
          margin-right: 20px;
        }
      }
      &-body {
        margin-left: 70px;
        img.photo {
          display: block;
          width: 100%; height: 120px;
          object-fit: cover;
          border-radius: 5px;
        }
        .merchant-info {
          background: #eee;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
